import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { PACIMPgpWithProvider } from '@core/model';
import { ServicingFacilityContactDetailsPAC } from '@shared/model';

@Component({
    selector: 'servicing-facility-info',
    templateUrl: './servicing-facility-info.component.html',
    styleUrls: ['./servicing-facility-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ServicingFacilityInfoComponent {
  @Input() contactDetails: ServicingFacilityContactDetailsPAC;
  @Input() servicingFacility: PACIMPgpWithProvider;
  @Input() isExternalFlow!: boolean;
  @Input() tenantName: string;
  @Input() isGoldCardVisible = false;

  @Output() detailsChanged = new EventEmitter<ServicingFacilityContactDetailsPAC>();

  setContactDetails(
    details: ServicingFacilityContactDetailsPAC | null
  ): void {
    this.detailsChanged.emit(details);
  }

}
